<template>
  <b-overlay :show="isFetching" variant="white" opacity="1" no-fade>
    <template #overlay>
      <b-icon
        icon="three-dots"
        animation="cylon"
        variant="primary"
        scale="2"
        shift-v="8"
        shift-h="8"
        class="position-absolute"
      ></b-icon>
    </template>

    <BaseHeader>
      <router-link
        :to="{ name: 'Companies' }"
        class="btn btn-primary btn-icon-only p-0 mr-4 rounded-circle"
      >
        <b-icon icon="arrow-left"></b-icon>
      </router-link>

      <h2 v-if="company.id" class="header-title m-0">
        {{ company.name }}
      </h2>
    </BaseHeader>

    <div class="bg-jungle-mist">
      <b-container>
        <b-row>
          <b-col>
            <b-list-group horizontal="md" class="list-group-nav">
              <b-list-group-item
                :class="{
                  active: 'ManageCompanyProfile' == $route.name
                }"
                class="border-0"
              >
                <router-link :to="{ name: 'ManageCompanyProfile' }"
                  >Company Profile</router-link
                >
              </b-list-group-item>
              <b-list-group-item
                :class="{
                  active: 'ManageCompanyUsers' == $route.name
                }"
                class="border-0"
              >
                <router-link :to="{ name: 'ManageCompanyUsers' }"
                  >Users</router-link
                >
              </b-list-group-item>
              <b-list-group-item
                :class="{
                  active: 'ManageCompanyReports' == $route.name
                }"
                class="border-0"
              >
                <router-link :to="{ name: 'ManageCompanyReports' }"
                  >Reports</router-link
                >
              </b-list-group-item>
              <b-list-group-item
                :class="{
                  active: 'ManageCompanyRLS' == $route.name
                }"
                class="border-0"
              >
                <router-link :to="{ name: 'ManageCompanyRLS' }"
                  >RLS</router-link
                >
              </b-list-group-item>
              <b-list-group-item v-if="company.role.role === 'Underwriter' || company.role.role === 'TPA' || company.role.role === 'Broker'"
                :class="{
                  active: 'ManageCompanyCashCall' == $route.name
                }"
                class="border-0"
              >
                <router-link :to="{ name: 'ManageCompanyCashCall' }"
                  >Cash Call</router-link
                >
              </b-list-group-item>
              <b-list-group-item v-if="company.role.role === 'Underwriter'"
                :class="{
                  active: 'ManageCompanyCustomValidations' == $route.name
                }"
                class="border-0"
              >
                <router-link :to="{ name: 'ManageCompanyCustomValidations' }"
                  >Custom Validations</router-link
                >
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="py-4 py-md-5">
      <b-container class="my-2">
        <template v-if="company.id">
          <fade-transition :duration="200" origin="center top" mode="out-in">
            <router-view :company="company"
            ></router-view>
          </fade-transition>
        </template>
      </b-container>
    </div>
  </b-overlay>
</template>

<script>
import {
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount
} from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'
import { useRoute } from 'vue2-helpers/vue-router'
import { FadeTransition } from 'vue2-transitions'

import { CompanyService } from '@services'
import { BaseHeader } from '@components/base'

export default defineComponent({
  name: 'ViewCompany',
  components: {
    FadeTransition,

    BaseHeader
  },
  setup() {
    const { useGetters, useMutations } = createVuexHelpers()

    const { company } = useGetters(['company'])
    const { READ_COMPANY } = useMutations(['READ_COMPANY'])

    const route = useRoute()

    const isFetching = ref(true)

    const fetchData = async () => {
      try {
        const { data } = await CompanyService.read(route.params.id)
        const { data: results } = data || {}

        isFetching.value = false

        READ_COMPANY(results)
      } catch (_) {
        isFetching.value = false

        READ_COMPANY(null)
      }
    }

    onMounted(fetchData)

    onBeforeUnmount(() => READ_COMPANY(null))

    return {
      company,

      isFetching,
      fetchData
    }
  }
})
</script>
